// Module
var code = "<div> <div>{{transition.name}}</div> <div translate>{{transition.status}}</div> <div ng-if=!transition.finalizedTimestamp>{{transition.estimatedTimestamp | date:'short'}}</div> <div ng-if=!!transition.finalizedTimestamp>{{transition.finalizedTimestamp | date:'short'}}</div> </div>";
// Exports
module.exports = code;